import cssUtil from 'gw-portals-util-js/CssUtil';

import template from 'text!./MobileHeader.html';
import styles from './MobileHeader-hashed.scss';

export default (function () {
    return {
        restrict: 'E',
        transclude: true,
        replace: true,
        scope: {
            onBack: '&'
        },
        template: cssUtil.hashTemplate(template, styles)
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/pagestructure/mobileheader/MobileHeader.js
// module id = 1143
// module chunks = 0